import { render, staticRenderFns } from "./ksnackbar.vue?vue&type=template&id=e70f3320&scoped=true"
import script from "./ksnackbar.vue?vue&type=script&lang=js"
export * from "./ksnackbar.vue?vue&type=script&lang=js"
import style0 from "./ksnackbar.vue?vue&type=style&index=0&id=e70f3320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70f3320",
  null
  
)

export default component.exports